var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgLongvertical({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 22,
    height: 24,
    viewBox: "0 0 22 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Component 1"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M16.25 0L21.25 5L16.25 10V0Z",
    fill: "#16478E"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_2",
    d: "M16.25 14L21.25 19L16.25 24V14Z",
    fill: "#16478E"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Rectangle 10"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "path-3-outside-1_292_3937",
    maskUnits: "userSpaceOnUse",
    x: 0.25,
    y: 0,
    width: 14,
    height: 24,
    fill: "black"
  }, /*#__PURE__*/React.createElement("rect", {
    fill: "white",
    x: 0.25,
    width: 14,
    height: 24
  }), /*#__PURE__*/React.createElement("path", {
    d: "M13.25 0L13.25 24H1.25L1.25 0L13.25 0Z"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M13.25 0L13.25 24H1.25L1.25 0L13.25 0Z",
    fill: "#E3EFFB"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12.25 0L12.25 24H14.25L14.25 0L12.25 0ZM2.25 24L2.25 0L0.25 0L0.25 24H2.25Z",
    fill: "#16478E",
    mask: "url(#path-3-outside-1_292_3937)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLongvertical);
export default __webpack_public_path__ + "static/media/longvertical.5953fffaacfdf55676f78f4cae394e70.svg";
export { ForwardRef as ReactComponent };